// Calculating.js

const Calculating = () => {
  return (
    <div className="calculatingContainer">
      <p>Comparing all ratings</p>
      <div class="calculatingBar">
        <div class="color"></div>
      </div>
    </div>
  );
};

export default Calculating;
